import { EmergencyHomeFilled, Upload } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React, { useRef, useState } from 'react';
import { MaybeWrapper } from "../../helper/components/MaybeWrapper.js";
import { handleFiles } from "../../helper/functions/handleFiles.js";
import { DropZone } from "../DropZone/DropZone.js";
import { AddButton } from "../addButton/AddButton.js";
import styles from "./UploadButton.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ICON_SIZE = 20;
export const UploadButton = ({
  onChange,
  horizontal,
  variant = 'white',
  error = false,
  disabled,
  accept,
  multiple,
  disableInputResetAfterUpload,
  disableDropZone = false,
  className,
  dropZoneProps,
  ...addButtonProps
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);
  const classes = classnames(styles.uploadButton, className);
  const buttonClasses = classnames({
    [styles.gray]: variant === 'gray',
    [styles.error]: error,
    [styles.isDragging]: isDragging
  });
  const buttonProps = {
    ...addButtonProps,
    name: !disableDropZone && isDragging && dropZoneProps?.name || addButtonProps.name,
    description: !disableDropZone && isDragging && dropZoneProps?.description || addButtonProps.description,
    className: buttonClasses,
    variant: horizontal ? 'HORIZONTAL_BOX' : 'VERTICAL_BOX',
    isLoading: isUploading,
    icon: /*#__PURE__*/_jsx(Upload, {
      size: ICON_SIZE,
      className: styles.icon
    }),
    iconSize: ICON_SIZE,
    onClick: () => fileInputRef.current?.click()
  };
  const handleChange = async event => {
    if (event.target.files?.length) {
      setIsUploading(true);
      try {
        if (onChange) {
          await handleFiles(event.target.files, onChange);
          if (fileInputRef.current && !disableInputResetAfterUpload) {
            fileInputRef.current.value = '';
          }
        }
      } finally {
        setIsUploading(false);
      }
    }
  };
  const handleDrop = async files => {
    setIsUploading(true);
    try {
      if (onChange) {
        await handleFiles(files, onChange);
        if (fileInputRef.current && !disableInputResetAfterUpload) {
          fileInputRef.current.value = '';
        }
      }
    } finally {
      setIsUploading(false);
    }
  };
  const dropZoneWrapper = c => /*#__PURE__*/_jsx(DropZone, {
    name: "Datei hier ablegen",
    onDrop: handleDrop,
    onDragEnter: () => setIsDragging(true),
    onDragLeave: () => setIsDragging(false),
    disableOverlay: true,
    ...dropZoneProps,
    children: c
  });
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    children: [/*#__PURE__*/_jsx("input", {
      type: "file",
      accept: accept,
      multiple: multiple,
      onChange: handleChange,
      disabled: disabled,
      style: {
        display: 'none'
      },
      ref: fileInputRef
    }), /*#__PURE__*/_jsx(MaybeWrapper, {
      condition: !disableDropZone,
      wrapper: dropZoneWrapper,
      children: /*#__PURE__*/_jsx(AddButton, {
        ...buttonProps
      })
    }), error && /*#__PURE__*/_jsxs("div", {
      className: styles.errorMessage,
      children: [/*#__PURE__*/_jsx(EmergencyHomeFilled, {
        size: ICON_SIZE,
        className: styles.icon
      }), /*#__PURE__*/_jsx("span", {
        children: error
      })]
    })]
  });
};